import { Player } from "@lottiefiles/react-lottie-player";
import { requireAsset } from "../utils/asset";
import NavBar from "../components/general/NavBar";
import { AiFillStar } from "react-icons/ai";


const OnboardingCompleteView = ({ onComplete }) => {
  return (
    <div className="z-[51] fixed top-0 left-0 flex h-screen w-screen flex-col bg-gradient-to-b from-accent/20 via-background to-background">
      <NavBar />
      <div className="flex grow items-center justify-center px-4 pb-20">
        <div className="flex w-full max-w-md flex-col items-center rounded-3xl border border-accent/40 bg-white/80 px-6 py-8 text-center shadow-large sm:px-10">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent/30 px-4 py-2 text-sm font-bold text-txt_primary">
            <AiFillStar className="text-accentdark" aria-hidden="true" />
            Setup complete
            <AiFillStar className="text-accentdark" aria-hidden="true" />
          </div>
          <h1 className="font-MS text-4xl font-extrabold">All done!</h1>
          <div className="relative my-2 flex h-60 w-60 items-center justify-center">
            <AiFillStar className="absolute left-2 top-8 text-2xl text-accentdark" aria-hidden="true" />
            <AiFillStar className="absolute right-2 top-12 text-lg text-accent" aria-hidden="true" />
            <AiFillStar className="absolute bottom-8 right-4 text-2xl text-accentdark" aria-hidden="true" />
            <Player
              src={requireAsset("success.json")}
              className="h-full w-full"
              keepLastFrame
              autoplay
            />
          </div>
          <p className="text-lg font-semibold">Thank you!</p>
          <p className="mt-1 text-sm text-txt_primary_light">
            You’re all set and ready to get started.
          </p>
        </div>
      </div>
      <div className="fixed bottom-4 left-1/2 flex -translate-x-1/2 flex-row">
        <button
          onClick={() => onComplete()}
          className="min-w-[180px] rounded-lg bg-accent p-5 text-center text-lg font-semibold shadow-default transition duration-200 hover:scale-105 hover:bg-accentdark focus:outline-none focus:ring-2 focus:ring-accentdark focus:ring-offset-2"
        >
          Go To Dashboard
        </button>
      </div>
    </div>
  );
};

export default OnboardingCompleteView;